import React from 'react';
import { useSelector } from 'react-redux';
import { Banner } from 'Features/MyAccount/PromoBanner/Banner';

export const PromoBannerContainer = ({ promoBanner, useDetailsBanner }) => {
  const { routes } = useSelector((s) => s.appConfig);
  const bannerImage = useDetailsBanner ? promoBanner.promotionDetailsBanner : promoBanner.banner;
  const planId = promoBanner.bannerSKU;
  const bannerLink = `${routes.payment}/${planId}`;

  return <Banner image={bannerImage} className={promoBanner.className} bannerLink={bannerLink}></Banner>;
};
